import { GetterTree } from 'vuex';
import { State } from './tokenManager.store';

const getters: GetterTree<State, State> = {
    getTokenList: state => {
        return state.tokenList;
    },
    getPrevRoute: state => {
        return state.prevRoute;
    },
    getIsGlobalTokenActive: state => {
        return state.isGlobalTokenActive;
    },
    getSearchTokenName: state => {
        return state.searchTokenName;
    },
    getAllMappedTokensDeleted: state => {
        return state.allMappedTokensDeleted;
    },
    getTokenId: state => {
        return state.tokenId;
    },
    getTokenName: state => {
        return state.tokenName;
    },
    getIsTokenDeleteActive: state => {
        return state.isTokenDeleteActive;
    },
    getTokenPageNum: state => {
        return state.tokenPageNum
    },
    getTokenSortParams: state => {
        return state.tokenSortParams
    },
    getIsTokenFormOpen: state => {
        return state.isTokenFormOpen;
    },
    getTokenFormData: state => {
        return state.tokenFormData;
    }
}

export default getters;